import { AxiosPromise } from 'axios';
import { surferAxios } from 'src/app/utils/axios.instance';
// import { axios } from "src/app/utils";
import {
  BlockResultType,
  BlockStatistic,
  BlockStatisticCreate,
  BulkDataCountResultType,
  DataCountResultType,
  EstimationResultType,
  GeotemporalType,
  GetBlockDataType,
  GetNetworkDataType,
  NSearchResultType,
  PreviousInterestLocationsType,
  TimelineResponseType,
  TThreadNetworkResult,
} from 'src/app/services/surfer-service/surfer.service.type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';
import { BlockStatisticStatus } from 'src/enums/surfer.enums';
import { BulkDataCountType, DataCountType, EstimationType, NSearchType } from 'src/types/query.type';

export const nSearch = (
  nsearchQuery: NSearchType,
  params?: { limit?: number; offset?: number },
): AxiosPromise<NSearchResultType> => {
  return surferAxios.post(finalUrlsConfig().surfer.mediaInsights, nsearchQuery, { params });
};

export const getInterestLocation = (interests: string[]): AxiosPromise<GeotemporalType[]> => {
  return surferAxios.post(finalUrlsConfig().surfer.interestLocation, { interests });
};

export const getInterestsPreviousLocation = (interest: string): AxiosPromise<PreviousInterestLocationsType[]> => {
  return surferAxios.post(finalUrlsConfig().surfer.interestLocation, { interest });
};

export const estimation = (estimationQuery: EstimationType): AxiosPromise<EstimationResultType> => {
  return surferAxios.post(finalUrlsConfig().surfer.estimation, estimationQuery);
};
export const dataCount = (
  dataCountQuery: DataCountType,
  counterServerURL: string,
): AxiosPromise<DataCountResultType> => {
  return axios.post(finalUrlsConfig().counter.dataCount, dataCountQuery, {
    baseURL: counterServerURL,
  });
};

export const bulkDataCount = (
  bulkDataCountQuery: BulkDataCountType,
  surferURL: string,
): AxiosPromise<BulkDataCountResultType> => {
  return axios.post(finalUrlsConfig().surfer.bulkDataCount, bulkDataCountQuery, {
    baseURL: surferURL,
  });
};

export const getBlock = ({ enterpriseId, blockID }: GetBlockDataType): AxiosPromise<BlockResultType> => {
  return surferAxios.post(finalUrlsConfig().surfer.blockOriginal, {
    blockID,
    enterpriseId,
  });
};

export const getNetwork = (networkQuery: GetNetworkDataType): AxiosPromise<TThreadNetworkResult> => {
  return surferAxios.post(finalUrlsConfig().surfer.network, networkQuery);
};

export const getBlockStatisticStates = (): AxiosPromise<{
  count: number;
  rows: BlockStatistic[];
}> => {
  return axios.get(finalUrlsConfig().surfer.blockStatistic.lookup);
};

export const giveBlockFeedback = (data: BlockStatisticCreate): AxiosPromise<BlockStatistic> => {
  return axios.post(finalUrlsConfig().surfer.blockStatistic.create, data);
};

export const updateBlockFeedback = (id: string, status: BlockStatisticStatus): AxiosPromise<BlockStatistic> => {
  return axios.patch(`${finalUrlsConfig().surfer.blockStatistic.update}/${id}`, {
    status,
  });
};

export const deleteBlockFeedback = (id: string): AxiosPromise<void> => {
  return axios.delete(`${finalUrlsConfig().surfer.blockStatistic.delete}/${id}`);
};

export const getTimelineData = (body: { interestIds: [string, string] }): AxiosPromise<TimelineResponseType[]> => {
  return surferAxios.post(finalUrlsConfig().surfer.timeline, body);
};
